import templateUrl from "emun.media/media-prompt.htm";
import controller from "emun.media/media-prompt.controller";
import open from "webmodals/open";
import moment from "moment";

export default ({
  size = "sm",
  backdrop = "static",
  placement = undefined, // "right",
  preventAutoHeight = true,
  media = {},
  add = !media.id,
  okButtonText = add ? "Add" : "Save",
  title = `${add ? "Create" : "Edit"} Media...`,
  commandUrl = `${
    add ? "Create" : "Update"
  }Media.json?jsconfig=ua,uaa`,
  colSplit = 3,
  subTitle = media.label
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        media: {
          type: 'Hotspot',
          publishOn: moment.utc().startOf('date').add('month', 1).toDate(),
          expiresOn: moment.utc().startOf('date').add('year', 2).toDate(),
          ...media
        },
        title,
        subTitle,
        commandUrl,
        colSplit,
        preventAutoHeight,
        okButtonText
      })
    }
  }).result;
